import Cookies from 'js-cookie'

export default class CookieConsent {
    constructor(element) {
        this.root = element
        this.cookieName = 'cookie-consent'
        this.agreeButton = this.root.querySelector('.cookie-consent-agree')
        this.closeButton = this.root.querySelector('.cookie-consent-close')

        // Click agree button
        this.agreeButton.addEventListener('click', (event) => this.handleAgreeClick(event))

        // Click close button button
        this.closeButton.addEventListener('click', (event) => this.handleCloseClick(event))

        // Read cookie and toggle
        if(this.hasAgreed()) {
            this.hide()
        } else {
            this.show()
        }
    }

    hasAgreed() {
        return this.getCookie() === '1'
    }

    handleAgreeClick(event) {
        event.preventDefault()
        this.setCookie()
        this.hide()
    }

    handleCloseClick() {
        event.preventDefault()
        this.setCookie()
        this.hide()
    }

    getCookie() {
        return Cookies.get(this.cookieName)
    }

    setCookie() {
        Cookies.set(this.cookieName, '1', {secure: true, expires: 365})
    }

    show() {
        this.root.style.display = 'block'
    }

    hide() {
        this.root.style.display = 'none'
    }
}